<template>
    <v-dialog
        v-model="isDialogOpen"
        width="1000"
    >
        <v-card>
            <v-toolbar
                flat
            >
                <v-toolbar-title class="pl-6">
                    <span class="font-weight-bold">{{ headerTitle }}</span>
                </v-toolbar-title>
                <v-toolbar-items class="pr-2 ml-auto">
                    <v-btn
                        icon
                        @click.native="$emit('close')"
                    >
                        <v-icon>close</v-icon>
                    </v-btn>
                </v-toolbar-items>
            </v-toolbar>
            <v-container>
                <v-form
                    ref="form"
                    v-model="formValid"
                >
                    <v-row>
                        <v-col>
                            <v-autocomplete
                                v-model="formData.attributeIDs"
                                :label="$t('attribute')"
                                :items="attributes"
                                :rules="[rules.notEmpty]"
                                item-text="localName"
                                item-value="id"
                                hide-no-data
                                cache-items
                                clearable
                                multiple
                                color="teal lighten-2"
                                item-color="teal lighten-2"
                            ></v-autocomplete>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                            <v-autocomplete
                                v-model="formData.categoryIDs"
                                :items="categories"
                                :label="$t('category')"
                                :rules="[rules.notEmpty]"
                                item-text="localName"
                                item-value="id"
                                hide-no-data
                                cache-items
                                clearable
                                multiple
                                color="teal lighten-2"
                                item-color="teal lighten-2"
                            ></v-autocomplete>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                            <v-text-field
                                v-model="formData.valueNameRu"
                                :label="$t('nameRu')"
                                :rules="[rules.required]"
                                color="teal lighten-2"
                                item-color="teal lighten-2"
                            ></v-text-field>
                        </v-col>
                        <v-col>
                            <v-text-field
                                v-model="formData.valueNameUa"
                                :label="$t('nameUa')"
                                :rules="[rules.required]"
                                color="teal lighten-2"
                                item-color="teal lighten-2"
                            ></v-text-field>
                        </v-col>
                    </v-row>
                </v-form>
            </v-container>
            <v-card-actions>
                <v-btn
                    depressed
                    class="white--text teal"
                    width="130"
                    :disabled="!formValid"
                    @click="validate"
                >{{$t('save')}}</v-btn>
                <v-btn
                    @click="$emit('close')"
                >{{ $t('cancel') }}</v-btn>
            </v-card-actions>
        </v-card>

    </v-dialog>
</template>

<script>
import { MixinDialogRemote, MixinTextFieldValidators } from '../../mixins';
import {AttributesService, InfoService} from "../../services";

export default {
    name: "EnumAttributeValueDialog",
    mixins: [ MixinDialogRemote, MixinTextFieldValidators ],
    props: [ 'dialogType', 'initialAttribute', 'attributeValueID' ],
    data() {
        return {
            categories: [],
            attributes: [],
            formValid: false,
            formData: {
                attributeIDs: [],
                categoryIDs: [],
                valueNameRu: null,
                valueNameUa: null,
            },
        }
    },
    computed: {
        headerTitle() {
            return `${this.$t(this.dialogType)} ${this.$t('attributeValue').toLowerCase()}`;
        }
    },
    methods: {
        resetForm() {
            this.formData = {
                attributeIDs: [],
                categoryIDs: [],
                valueNameRu: null,
                valueNameUa: null,
            };
        },
        setAttributes() {
            InfoService.setAuth(this.$store.getters.token);
            InfoService.getAttributesEnumAttributes()
                .then(res => {
                    this.attributes = res.data;
                })
                .catch(err => {
                    console.log(err);
                })
        },
        setCategories() {
            InfoService.setAuth(this.$store.getters.token);
            InfoService.getAttributesCategories()
                .then(res => {
                    this.categories = res.data;
                })
                .catch(err => {
                    console.log(err);
                })
        },
        setInitialData() {
            AttributesService.setAuth(this.$store.getters.token);
            AttributesService.getAttributeValue(this.attributeValueID)
                .then(res => {
                    this.formData = {
                        attributeIDs: res.data.attributesIDs,
                        categoryIDs: res.data.categoryIDs,
                        valueNameRu: res.data.valueNameRu,
                        valueNameUa: res.data.valueNameUa,
                    };
                })
                .catch(err => {
                    console.log(err);
                })
        },
        validate() {
            if (this.$refs.form.validate()) {
                const params = {...this.formData};
                if (this.dialogType === 'edit') this.$set(params, 'id', this.attributeValueID);
                this.$emit('validated', params);
            }
        }
    },
    watch: {
        isDialogOpen(value) {
            if (value) {
                this.resetForm();
                this.setCategories();
                this.setAttributes();
                if(this.dialogType === 'edit') {
                    this.setInitialData();
                }
            }
        },
    }
}
</script>

<style scoped>

</style>
